import React, { useState, useEffect } from 'react';
import ProcedureCatalogListMobile from './procedureCatalogListMobile';
import ProcedureCatalogListWeb from './procedureCatalogListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const ProcedureCatalogListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <ProcedureCatalogListMobile /> : <ProcedureCatalogListWeb />;
};

export default ProcedureCatalogListRouter;
